import { mapGetters, mapActions } from 'vuex'

import RankWrapper from '@/components/SheetDetailWrapper/index'
import MainButton from '@/components/MainButton/index'
import LazyImage from '@/components/LazyImage/index'

import { formatRank } from '@/utils/formatRank'

export default {
  name: 'profile',
  components: {
    RankWrapper,
    MainButton,
    LazyImage
  },
  data: () => ({
    hasGroup: false,
    inviteArr: null,
    lastWeekPoints: 0,
    continentalRanking: null,
    globalRanking: null,
    totalPoints: 0,
    currentUserId: null
  }),
  methods: {
    ...mapActions('profile', {
      fetchGroupAction: 'FETCH_MYGROUP',
      fetchMyInviteAction: 'FETCH_MYINVITE',
      transactInviteAction: 'TRANSACT_INVITE'
    }),
    ...mapActions('predictions', {
      fetchUserStatus: 'FETCH_USER_STATUS'
    }),
    createGroup() {
      this.$router.push({ name: 'create-group-invite' })
    },
    selectGroup(groupIndex) {
      this.$store.commit('SET_SELECTED_GROUP_INDEX', groupIndex)
      this.$router.push({ path: 'dashboard/leaderboard' })
    },
    inviteTransact(payload) {
      this.transactInviteAction(payload).then(() => {
        if (this.INVITE_TRANSACT_RESPONSE.success) {
          this.inviteArr = this.inviteArr.filter(
            invite => invite.id !== payload.id
          )

          this.fetchGroupAction()
          this.$store.commit('SET_INVITE_COUNT', this.INVITE_COUNT - 1)
        }
      })
    }
  },
  computed: {
    ...mapGetters('profile', [
      'GROUP_ARR',
      'INVITE_ARR',
      'INVITE_TRANSACT_RESPONSE',
      'INVITE_COUNT'
    ]),
    ...mapGetters('auth', ['USER_OBJ']),
    ...mapGetters('predictions', {
      fetchUserStatusResponse: 'USER_STATUS'
    }),
    fullName() {
      const { firstName, lastName } = this.USER_OBJ
      return `${firstName} ${lastName}`
    },
    countryName() {
      return this.USER_OBJ.continent
    },
    username() {
      const { username } = this.USER_OBJ
      return `${username}`
    }
  },
  watch: {
    GROUP_ARR(data) {
      this.hasGroup = data.length > 0
    }
  },
  activated() {
    this.currentUserId = this.USER_OBJ.id
    this.$store.commit('SET_PAGE_TITLE', 'profile')
    this.$store.commit('SET_HEADER_TABS', null)
    this.$store.commit('SET_HEADER_EDIT_VISITBILITY', true)

    this.fetchGroupAction()
    this.fetchMyInviteAction().then(() => {
      this.inviteArr = this.INVITE_ARR.data
    })
    this.fetchUserStatus().then(() => {
      const {
        data: {
          lastWeekPoints: { lastWeekPoints },
          totalAndContinentalRank,
          totalAndGlobalRank
        }
      } = this.fetchUserStatusResponse

      this.lastWeekPoints = lastWeekPoints || 0

      const continentalRanking = totalAndContinentalRank
        ? formatRank(parseInt(totalAndContinentalRank.rank))
        : '---'
      this.continentalRanking = continentalRanking

      const totalGlobalRanking = totalAndGlobalRank || 0

      const globalRanking = totalGlobalRanking
        ? formatRank(parseInt(totalGlobalRanking.rank))
        : '---'
      this.globalRanking = globalRanking

      const totalPoints = totalGlobalRanking
        ? totalGlobalRanking.total || 0
        : totalGlobalRanking
      this.totalPoints = totalPoints
    })
  },

  deactivated() {
    this.$store.commit('SET_HEADER_EDIT_VISITBILITY', false)
    this.inviteArr = null
  }
}
